

import Home from './Components/Home/Home';
import './App.css';
import Navbar from './Components/Navbar/Navbar';
import AboutMe from './Components/aboutme/aboutme.jsx';
import ProjectList from './Components/Projects/ProjectList.jsx';
import Skills from './Components/Skills/Skills.jsx';
import Experience from './Components/Experience/Experience.jsx';
import Contact from './Components/Contact/Contact.jsx';
import Footer from './Components/Footer/Footer.jsx';
function App() {
  return (
    <div className="App">
      <Navbar />
      <Home/>
      <AboutMe/>
     <ProjectList />
     <Skills />
     <Experience />
     <Contact />
     <Footer />
    </div>
  );
}

export default App;
